<template>
    <div id="web-newsContent">
        <div class="newList">
            <!-- <img v-if="deviceType == 'desktop'" class="d-block img-fluid w-100 d-none d-md-block"
                :src="newsHeaderImagePc" alt="image slot">
            <img v-else class="d-block img-fluid w-100 d-md-none" :src="newsHeaderImageMobile" alt="image slot"> -->
            <div class="d-none d-md-block">
                <b-img :src="newsHeaderImagePc" fluid alt="Responsive image"></b-img>
            </div>
            <div class="d-md-none">
                <b-img :src="newsHeaderImageMobile" fluid alt="Responsive image"></b-img>
            </div>
            <router-view></router-view>
        </div>
    </div>
</template>
<script>
    // 获取设备类型（简单示例，实际上最好使用CSS媒体查询辅助判断）
    function getDeviceType() {
        const width = window.innerWidth || document.documentElement.clientWidth;
        if (width > 768) {
            return 'desktop';
        } else {
            return 'mobile';
        }
    }
    export default {
        name: "newsContent",
        components: {
        },
        data() {
            return {
                deviceType: "desktop",
                // newsHeaderImagePc: JSON.parse(localStorage.getItem("websiteConfig")).newsHeaderImagePc,   //,
                // newsHeaderImageMobile: JSON.parse(localStorage.getItem("websiteConfig")).newsHeaderImageMobile,
                newsHeaderImagePc: require('@/assets/web/img/News-Announcement-PC.png'),
                newsHeaderImageMobile: require('@/assets/web/img/News-Announcement-phone.png'),
                slide: 0,
            };
        },
        created() {
            this.deviceType = getDeviceType();
            this.newsHeaderImagePc = JSON.parse(localStorage.getItem('websiteConfig')).newsHeaderImagePc
            this.newsHeaderImageMobile = JSON.parse(localStorage.getItem('websiteConfig')).newsHeaderImageMobile

        },
        destroyed() {
        },
        async mounted() {
        },
        methods: {

        },
    }
</script>